<div class="section termsrow">
    <div class="container-fluid">
        <div class="row" style="height:360px">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Privacy Policy</h3>
                            </header>                           
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<section>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="privacyMain">
                    <div>
                        <h1>Privacy Policy for SFI Compliance, Inc. 
                            (SFI Safety App)
                        </h1>
                    </div>
                    <hr>
                    <p >Last Modified on November 14, 2025</p>
                    <div>
                        <h2 class="header">Introduction</h2>
                        <p>At SFI Compliance, Inc. <strong>(“SFI”)</strong>, your privacy is of utmost importance. This Privacy Policy explains how SFI collects, uses, discloses, and safeguards your information when you use the SFI Safety App <strong>("SFI Application")</strong> for safety related services <strong>(“Service”)</strong>, including Jobsite Inspections, Checklist Inspections, Safety Observations, Tool Box Talks, Safety Meetings, Safety Training, Incident Reporting, and other safety related services available in the SFI Application.  
                        </p>
                    <br>
                    <p>By using the SFI Application, you agree to the terms of this Privacy Policy.</p>
                    </div>
                    <div>
                        <h2 class="header">01. Information SFI Collects. SFI may collect the following types of information:</h2>
                        <p>We may collect the following types of information:</p>

                         <p> a) Personal Information</p>
                           <p> o Name, email address, phone number </p>
                           <p> o Company name and location</p>
                           <p> o Signature or initials (if required for services)</p>
                         
                         <p> b) Service  Data</p>
                            <p>o Photos, videos, audio recordings (uploaded manually by you or taken via the SFI Application). </p>
                            <p>o GPS location (only during active services, if permission granted).</p>
                            <p>o Service notes, checklists, and form entries.</p>

                         <p> c) Device Information</p>
                            <p>o Device type, model, and operating system</p>
                            <p>o SFI Application version and usage data (crash logs, performance metrics).</p>
                            
                        
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">02. How SFI May Use Your Information.  SFI may use the collected information to:</h2>
                        <!-- <p>We use the collected information to: </p> -->
                            <p>a) Facilitate services</p>
                            <p>b) Generate and share service reports. </p>
                            <p>c) Improve the performance and functionality of the SFI Application. </p>
                            <p>d) Provide customer support.</p>
                            <p>e) Ensure compliance with legal and safety obligations.</p>
                            
                        
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">03. Data Sharing and Disclosure.  SFI does not sell your personal data. SFI may share your information with:</h2>
                        <!-- <p>We do not sell your personal data. We may share your information with:</p> -->
                           <p>a) Authorized company administrators (e.g., your employer or organization)</p>
                           <p>b) Third-party service providers (e.g., cloud storage, analytics tools) strictly for operational purposes</p>
                           <p>c) Government authorities or regulators, when required by law</p>
                            
                        
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">04. Data Security.  SFI takes appropriate technical and organizational measures to secure your data, including:</h2>
                        <!-- <p>We take appropriate technical and organizational measures to secure your data, including: </p> -->
                           <p>a) Encrypted storage of sensitive information
                           <p>b) Secure transmission using HTTPS
                           <p>c) Role-based access control
                            However, please be aware that no system is 100% secure, and we cannot guarantee absolute data protection.</p>
                            
                       
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">05. Your Rights and Choices.  You may:</h2>
                        <!-- <p>You may:</p> -->
                           <p>a) Access and review your data</p>
                           <p>b) Request corrections or deletions</p>
                           <p>c) Withdraw consent (which will limit SFI Application functionality).</p>
                           <p>d) Contact SFI to deactivate your account.</p>
                            
                        
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">06. Data Retention</h2>
                        <p> SFI retains data only for as long as necessary to fulfill the purposes outlined 
                            above, unless a longer retention period is required by law or for record keeping.
                            
                        </p>
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">07. Permissions Used in the SFI Application.</h2>
                        <p>The SFI Application may request access to: </p>
                            <p>a) Camera: To capture service photos.</p>
                            <p>b) Location: To tag with GPS coordinates during services.</p>
                            <p>c) Storage: To save and upload reports or media.</p>
                            <p>d) Microphone: If audio notes are supported.
                              These permissions are used only to support inspection functionalities.</p>
                            
                            
                        
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">08. Children's Privacy</h2>
                        <p>The SFI Application is not intended for use by children under the age of 
                          18. SFI does not knowingly collect personal data from minors.
                        </p>
                    </div>
                    <div>
                        <h2 class="header">09. Changes to This Privacy Policy</h2>
                        <p>SFI may update this policy from time to time. Any changes 
                            will be posted in the SFI Application or on the website with the revision date.
                        </p>
                    </div>
                    <hr>
                    <div>
                        <h2 class="header">10. Contact</h2>
                        <p>If you have any questions about this Privacy Policy, please contact SFI at: </p>
                           <p> SFI Compliance, Inc.</p>
                           <p> Email: <a href="support@sficompliance.com">support@sficompliance.com</a></p>
                           <p> Phone: 303-649-1304</p>
                          <p>Website: <a href="https://www.sficompliance.com">https://www.sficompliance.com </a></p>
                            
                       
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
